export default __webpack_public_path__ + "static/facility-modal-default-7d682bdec04b7ac7f7892dd73c85d2e3.jpg";